module.exports = __webpack_public_path__ + "static/media/500Err.41c860e5.svg";